import { IconMicrophone, IconPlayerStop } from '@tabler/icons-react';
import React, { useState } from 'react';
import { ReactMediaRecorder } from 'react-media-recorder';
import { uploadFile } from '../../../../api/api.global';
import { socketKeys } from '../../../../statics/socketKeys';

const AudioRecorderForChat = ({ socket, visitorData }) => {
    const [isRecording, setIsRecording] = useState(false);

    const handleStop = async (blobUrl, blob) => {
        const fileName = visitorData?._id + new Date() + 'voice-message.webm';
        if (blob) {
            const file = new File([blob], fileName, {
                type: 'audio/webm',
            });
            let postData = {
                voice: await uploadFile(file, "chat"),
                chatSessionId: visitorData?._id,
                messageType: 3,
            }
            socket.emit(socketKeys.SEND_MESSAGE, postData);

        }
    };

    return (
        <ReactMediaRecorder
            audio
            onStop={handleStop}
            render={({ startRecording, stopRecording, mediaBlobUrl }) => (
                <>
                    <button
                        className={`p-2 hover:bg-gray-100 rounded-full hover:text-gray-500 hover:cursor-pointer transition ${isRecording
                            ? 'bg-red-300 text-red-600'
                            : 'text-white hover:text-gray-500 hover:bg-gray-100'
                            }`}
                        onClick={() => {
                            if (!isRecording) {
                                startRecording();
                                setIsRecording(true);
                            } else {
                                stopRecording(); // `handleStop` will be triggered
                                setIsRecording(false);
                            }
                        }}
                    >
                        {isRecording ? <IconPlayerStop size={20} className='text-gray-800' /> : <IconMicrophone size={20} className='text-gray-800' />}
                    </button>

                    {/* Optional Preview */}
                    {/* {mediaBlobUrl && (
                        <audio
                            src={mediaBlobUrl}
                            controls
                            className="mt-2 w-full max-w-xs rounded"
                        />
                    )} */}
                </>
            )}
        />
    );
};

export default AudioRecorderForChat;
